import { lazy } from "react";

const LoanApplicationForm = lazy(() => import("../Component/LoanApplication/LoanApplicationForm"));
const LoanApplicationList = lazy(() => import("../Component/LoanApplication/LoanApplicationList"));
const ShortLoanApplicationForm = lazy(() =>
  import("../Component/LoanApplication/ShortLoanApplicationForm")
);
const LoanDetails = lazy(() => import("../Component/LoanApplication/LoanDetails"));

const loanApplicationRoutes = [
  {
    path: "/loan-application-form/:uniqueLeadNumber/:leadId",
    element: <LoanApplicationForm />,
    protected: true,
  },
  { path: "/manage-loan-application", element: <LoanApplicationList />, protected: true },
  {
    path: "/short-loan-application-form/:uniqueLeadNumber/:leadId",
    element: <ShortLoanApplicationForm />,
    protected: true,
  },
  { path: "/loan-application-details/:id", element: <LoanDetails />, protected: true },
];

export default loanApplicationRoutes;
